import { z } from "zod";

/**
 * 06 §6.3.3 step 1: **the ticket every upload door hands out**, one contract for the doors and for every uploader
 * (`GENERIC-DOOR-SWEEP`, Arc 1, A48). The caller `PUT`s the file to `url` with `headers` verbatim, then confirms by `id`.
 * `POST /feature-requests/{id}/screenshot/ticket` is the first door typed by it; the vehicle photo and document tickets
 * (Arc 3) answer the same {@link UploadTicketDto} and take it next.
 */
export const uploadTicketSchema = z.strictObject({
  id: z.string(),
  url: z.string(),
  headers: z.record(z.string(), z.string()),
  /** ISO 8601. */
  expiresAt: z.string(),
});

export type UploadTicket = z.infer<typeof uploadTicketSchema>;
